module.exports = __webpack_public_path__ + "./docs/img/scheme_2.f1dc2dca1ec65a1cde34f41f803f3f0c.svg";